import { Component, Output, Input, EventEmitter, inject } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { AdminService } from '../../admin.service';
import { Application } from '../../../models/admin-models';
import { saveAs } from '@progress/kendo-file-saver';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-download-profile',
  templateUrl: './download-profile.component.html',
  styleUrls: ['../toolbox.component.scss'],
  imports: [
    MatSelectModule,
    MatRadioModule,
    FormsModule,
    MatButtonModule,
    MatInputModule,
  ],
})
export class DownloadProfileComponent {
  private admnSrvc = inject(AdminService);

  @Output() toggleLoading = new EventEmitter();
  @Input() applications: Application[];
  downloadProfile = {
    id: null,
    app: null,
    downloadXml: true,
    status: null,
    statusClass: null,
  };

  getProfileXml() {
    this.toggleLoading.emit();
    this.downloadProfile.status = null;
    this.downloadProfile.statusClass = null;
    if (this.downloadProfile.downloadXml) {
      this.admnSrvc
        .downloadXMLProfile(this.downloadProfile.id, this.downloadProfile.app)
        .subscribe({
          next: res => {
            this.toggleLoading.emit();
            let fileData;
            const filename = `${this.downloadProfile.app}-XMLProfile-${this.downloadProfile.id}.xml`;
            const reader = new FileReader();
            reader.readAsDataURL(res);

            reader.onloadend = () => {
              fileData = reader.result;
              saveAs(fileData, filename);
            };
          },
          error: catchError(err => {
            this.toggleLoading.emit();
            this.downloadProfile.status = err;
            this.downloadProfile.statusClass = 'failure';
            return throwError(() => err.error || 'Server error');
          }),
        });
    } else {
      this.admnSrvc
        .downloadJSONProfile(this.downloadProfile.id, this.downloadProfile.app)
        .subscribe({
          next: res => {
            this.toggleLoading.emit();
            let fileData;
            const filename = `${this.downloadProfile.app}-JSONProfile-${this.downloadProfile.id}.json`;
            const reader = new FileReader();
            reader.readAsDataURL(res);

            reader.onloadend = () => {
              fileData = reader.result;
              saveAs(fileData, filename);
            };
          },
          error: catchError(err => {
            this.toggleLoading.emit();
            this.downloadProfile.status = err;
            this.downloadProfile.statusClass = 'failure';
            return throwError(() => err.error || 'Server error');
          }),
        });
    }
  }
}
